export enum LiveListenState {
  OFF = 'off',
  ON = 'on',
}

export enum LiveListenDelayOptions {
  DELAY_NONE = 0,
  DELAY_15_SEC = 15,
  DELAY_30_SEC = 30,
}
